import { Box, Typography } from '@mui/material';
import React from 'react';
import { H3, PageArea, TableArea } from '../../components/ui/StyledComponents';
import { useI18n } from '../../hooks/I18n';
import { usePageTitleUpdateEffect } from '../../hooks/PageUtil';

const AboutPage: React.FC = () => {
  const i18n = useI18n();
  const pageTitle = i18n.LABELS.localize('page_title_about');
  usePageTitleUpdateEffect(pageTitle);

  return React.useMemo(
    () => (
      <Box
        sx={{
          display: 'flex', // 横幅はコンテンツに合わせる
          flexDirection: 'row', // 横方向に並べる
          flexWrap: 'wrap', // はみ出したら改行
          width: '100%', // 親の幅と合わせる
          maxWidth: '960px',
          m: 'auto', // 横のセンタリング
        }}
      >
        <PageArea title={pageTitle}>
          <TableArea title="本サイトについて">
            <Typography variant="body2" sx={{ px: 1 }}>
              スーパーフォーミュラとフォーミュラ・ニッポンのデータ収集と分析を行う個人サイトです。レース観戦がより面白くなる情報の提供を目指しています。
            </Typography>
          </TableArea>
          <TableArea title="同一データの扱い">
            <Typography component="div" variant="body2" sx={{ px: 1 }}>
              以下の愛称は下記の選手と同一としてランキングを計算しています。
              <ul>
                <li>
                  OSAMU
                  <ul>
                    <li>中嶋 修 選手</li>
                  </ul>
                </li>
              </ul>
            </Typography>
          </TableArea>
          <TableArea title="用語">
            <Typography component="div" variant="body2" sx={{ px: 1 }}>
              <ul>
                <li>PP ・・・ ポールポジションの略です。</li>
                <li>P2W ・・・ ポールトゥウィンの略です。</li>
              </ul>
            </Typography>
          </TableArea>
          <TableArea title="記録の計算方法">
            <H3 title="対象レース">
              <Typography variant="body2" sx={{ px: 1 }}>
                ポイントが得られるレースを計算の対象としています。以下のレースは対象から外しています。
                <ul>
                  <li>2010年~2012年 JAFグランプリ FUJI SPRINT CUP</li>
                </ul>
              </Typography>
            </H3>
            <H3 title="開催レース">
              <Typography variant="body2" sx={{ px: 1 }}>
                <ul>
                  <li>
                    1998年Round7、2017の最終戦(2レース制)、2018年Round2は決勝が開催されませんでしたが、予選が開催されたので1レースとして扱います。
                  </li>
                  <li>
                    2008年Round5~7、2010年から2016年の最終戦、2014年Round2、2016年Round5、2017年Round2は2レース制で実施されました。それぞれを個別のレースとして同等に扱います。
                  </li>
                  <li>
                    2011年Round5、2013年Round5は未開催のため1レースとして扱いません。
                  </li>
                  <li>
                    2017年Round7は2レース制でどちらのレースも決勝が開催されませんでしたが、予選が開催されたのでそれぞれを1レースとして扱います。
                  </li>
                  <li>
                    2025年Round10は予選が富士、決勝が鈴鹿で開催されたものとして扱います。出場数は両サーキットにカウントします。
                    表彰台数、勝利数は鈴鹿での記録として、PPは富士での記録として扱います。
                  </li>
                </ul>
              </Typography>
            </H3>
            <H3 title="出場">
              <Typography variant="body2" sx={{ px: 1 }}>
                あるレースにおけるフリー走行や予選、決勝などのいずれか1個に出場したドライバーは、出場として扱います。
              </Typography>
            </H3>
            <H3 title="ジャンプアップ">
              <Typography variant="body2" sx={{ px: 1 }}>
                予選の順位と決勝の順位の差に基づいて算出します。予選順位が無いマシンは算出外として扱います。
                決勝グリッド順が分かれば予選順位が無くても算出できますが、そのデータが揃っていないためです。以下は一例です。
              </Typography>
            </H3>
            <H3 title="連続記録">
              <Typography variant="body2" sx={{ px: 1 }}>
                <ul>
                  <li>
                    対象の選手がレースを欠場した場合、連続記録は途切れます。例えば欠場前のレースと欠場明けのレースの両方で優勝した場合、優勝の連続記録は2回連続とはなりません。
                  </li>
                  <li>
                    決勝未開催レースは、完走・表彰台・勝利・ポールトゥウィン・ファステストの連続記録の統計対象から除外します。
                  </li>
                  <li>
                    2008年Round5~7の第二レースはリバースグリッドによるグリッド決定のため、ポールポジション・ポールトゥウィンの連続記録の統計対象から除外します。
                  </li>
                </ul>
              </Typography>
            </H3>
            <H3 title="達成率">
              <Typography variant="body2" sx={{ px: 1 }}>
                <ul>
                  <li>
                    達成率は対象の選手が出場したレース数を分母、達成したレース数を分子とした割合です。
                  </li>
                  <li>
                    決勝未開催レースは、完走・表彰台・勝利・ポールトゥウィン・ファステストの達成率の分母から除外します。
                  </li>
                  <li>
                    2008年Round5~7の第二レースはリバースグリッドによるグリッド決定のため、ポールポジション・ポールトゥウィンの達成率の分母から除外します。
                  </li>
                </ul>
              </Typography>
            </H3>
            <H3 title="参戦中のみ">
              <Typography variant="body2" sx={{ px: 1 }}>
                最新年のレースに参戦したドライバーやメーカーを絞り込んで表示します。
              </Typography>
            </H3>
          </TableArea>
          <TableArea title="免責事項">
            <Typography variant="body2" sx={{ px: 1 }}>
              本サイトでは正確なデータや集計結果の提供を心がけていますが、それを保証するものではございません。また、本サイト、及びリンク先のサイトのご利用時において利用者が被った損害に対して、当方はいかなる責任も負わないものといたします。ご承知おきください。
            </Typography>
          </TableArea>
          <TableArea title="プライバシーポリシー">
            <Typography variant="body2" sx={{ px: 1 }}>
              当サイトでは、Googleの提供するアクセス解析ツール Google Analytics
              を利用しています。 Google Analytics
              はトラフィックデータ収集のためにCookieを使用していますが、このデータは匿名で収集されており、個人を特定するものではありません。また、この機能はCookieを無効にすることで収集を拒否することが可能です。
            </Typography>
          </TableArea>
        </PageArea>
      </Box>
    ),
    []
  );
};

export default AboutPage;
